// extracted by mini-css-extract-plugin
export default {"root":"Dropdown_root__48YGT","header":"Dropdown_header__zuSDE","container":"Dropdown_container__qbY0j","arrow":"Dropdown_arrow__u+I07"};